<template>
    <nav>
        <div class="content-block text-center survey-end-screen fill-height rounded-xxl"
            :class="{ 'pa-8': !mobileOverride(), 'pa-4' : mobileOverride(), 'mt-16': mobile() }"
            :style="{ 'background-color': color, 'margin-bottom': mobile() ? '120px' : '' }"> 
            <div>
                <v-row v-if="role == 'booster'" align="center" justify="center" no-gutters>
                    <v-col cols="12">
                        <p class="end-screen-title text-h5 font-weight-bold no-break" v-html="title"> </p>
                    </v-col>
                    <v-col cols="12" class="mt-3">
                        <p class="end-screen-description text-subtitle-2 font-weight-regular greytext--text no-break"
                            v-html="description"> </p>
                    </v-col>
                    <v-col cols="12" class="mt-5 mb-3">
                        <div class="survey-question-image-editor">
                            <img v-if="imageDisplay != null" :src="imageDisplay" :path="image" class="custom-image large">
                            <img v-else src="/assets/editor_images/artboard2.png" class="custom-image large">
                        </div>
                    </v-col>
                    <v-col cols="12" :sm="preview ? 12 : 6" :md="preview ? 12 : 6" lg = "6" class="mt-0 mb-3">
                        <div v-if="anonymous" style="width:180px;" class="text-left survey-user mx-auto">
                            <v-text-field dense outlined disabled class="rounded-lg pa-0 ma-0 text-body-2 mx-auto" :hide-details="true" :placeholder="$t('surveyStartAnonymousPlaceholder')" />
                        </div>
                        <div v-else class="text-left survey-user mx-auto">
                            <span class="text-caption greytext--text pl-3">{{ $t('answerAs') }}</span>
                            <v-text-field dense outlined disabled class="rounded-xxl pa-0 ma-0 text-body-2 mx-auto" :hide-details="true" :placeholder="name" />
                        </div>
                    </v-col>
                    <v-col cols="12" align="center" justify="center">
                        <v-btn data-testid="end-button" type="submit" color="accent" min-width="220" dark elevation="0"
                            class="rounded-xxl text-none px-4 white--text disable-events">
                            {{ $t('surveySubmit') }}
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-else align="center" justify="center" no-gutters>
                    <v-col cols="12" v-if="invalidAnswers.length > 0">
                        <p class="end-screen-title text-h5 font-weight-bold no-break error--text" >{{ $t('sorry') }}</p>
                    </v-col>
                    <v-col cols="12" v-else>
                        <p class="end-screen-title text-h5 font-weight-bold no-break" v-html="title"> </p>
                    </v-col>
                    <v-col cols="12" class="mt-3" v-if="invalidAnswers.length > 0">
                        <p class="end-screen-description text-subtitle-2 font-weight-regular greytext--text no-break">{{ $t('surveyUnansweredQuestionsInfo') }}</p>
                    </v-col>
                    <v-col cols="12" class="mt-3" v-else>
                        <p class="end-screen-description text-subtitle-2 font-weight-regular greytext--text no-break"
                            v-html="description"> </p>
                    </v-col>
                    <v-col cols="12" class="mt-5 mb-10" v-if="invalidAnswers.length > 0">
                        <v-btn data-testid="go-to-question-button" color="accent" min-width="220" depressed
                            class="rounded-xxl text-none px-4 " @click="$emit('redirectToUnasweredQuestion')">
                            {{ $t('goToQuestion') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="12" class="mt-5 mb-3" v-if="invalidAnswers.length == 0">
                        <div class="survey-question-image-editor">
                            <img v-if="imageDisplay != null" :src="imageDisplay" :path="image" class="custom-image large">
                            <img v-else src="/assets/editor_images/artboard2.png" class="custom-image large">
                        </div>
                    </v-col>
                    <v-col cols="12" class="mt-0 mb-3">
                        <div v-if="anonymous" style="width:180px;" class="text-left survey-user mx-auto">
                            <v-text-field dense outlined disabled class="rounded-lg pa-0 ma-0 text-body-2 mx-auto" :hide-details="true" :placeholder="$t('surveyStartAnonymousPlaceholder')" />
                        </div>
                        <div v-else class="text-left survey-user mx-auto" style="width:220px;">
                            <span class="text-caption greytext--text pl-3">{{ $t('answerAs') }}</span>
                            <v-text-field dense outlined disabled class="rounded-xxl pa-0 ma-0 text-body-2 mx-auto" :hide-details="true" :placeholder="nameUser" />
                        </div>
                    </v-col>
                    <v-col cols="12" align="center" justify="center">
                        <v-alert v-if="confirmationMsg == true" color="success" class="white--text mx-auto py-2 d-block rounded-xxl ma-0"   type="success" :value="true" width='250px'>
                            {{ $t('surveySubmitted') }}
                        </v-alert> 
                        <v-btn v-else data-testid="end-button" type="submit" :color="invalidAnswers.length > 0 ?'':'accent'" min-width="220" depressed
                            class="rounded-xl text-none px-4" :disabled="invalidAnswers.length > 0" @click="submitSurvey">
                            {{ $t('surveySubmit') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>
    </nav>
</template>
<script>
import { repeatedMethodsMixin } from '../../../../mixins/repeatedMethodsMixin'

export default {
    props: {
        anonymous: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        description: {
            type: String,
            default: null
        },
        imageDisplay: {
            type: String,
            default: null
        },
        image: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: '#FFFFFF'
        },
        role: {
            type: String,
            default: 'booster'
        },
        answers: {
            type: Array,
            default: () => []
        },
        invalidAnswers: {
            type: Array,
            default: () => []
        },
        confirmationMsg:{
            type: Boolean,
            default: false
        },
        nameUser: {
            type: String,
            default: null
        },
        preview: {
            type: Boolean,
            default: false
        },
    },
    components: {
    },

    mixins: [repeatedMethodsMixin],

    data() {
        return {
            name: localStorage.user ? JSON.parse(localStorage.user).first_name + " " + JSON.parse(localStorage.user).last_name : ''
        }
    },
    methods: {
        submitSurvey() {
            this.$emit('submitSurvey')
        },
        mobileOverride(){
            if(this.screen == 'mobile-view'){
                return true;
            }else{
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
            }
        },
    }
}
</script>

